@if (isOpen()) {
  <div class="profile-search__bar" role="search" [attr.aria-label]="'profileSearch.label' | translate">
    <mat-icon class="profile-search__icon" aria-hidden="true">search</mat-icon>
    <input
      #input
      class="profile-search__input"
      type="text"
      autocomplete="off"
      spellcheck="false"
      [maxLength]="maxLength"
      [value]="query()"
      [placeholder]="'profileSearch.placeholder' | translate"
      [attr.aria-label]="'profileSearch.label' | translate"
      (input)="onInput($any($event.target).value)"
      (keydown)="onInputKeydown($event)"
    />
    <!-- Für Screenreader sagt die Live-Region unten Position und Abschnitt an. -->
    <span class="profile-search__counter" aria-hidden="true">
      {{ search.position() }}/{{ search.total() }}
    </span>
    <button mat-icon-button type="button"
            [disabled]="search.total() === 0"
            [matTooltip]="'profileSearch.previous' | translate"
            [attr.aria-label]="'profileSearch.previous' | translate"
            (click)="search.previous()">
      <mat-icon>keyboard_arrow_up</mat-icon>
    </button>
    <button mat-icon-button type="button"
            [disabled]="search.total() === 0"
            [matTooltip]="'profileSearch.next' | translate"
            [attr.aria-label]="'profileSearch.next' | translate"
            (click)="search.next()">
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
    <button mat-icon-button type="button"
            [matTooltip]="'profileSearch.close' | translate"
            [attr.aria-label]="'profileSearch.close' | translate"
            (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
    <span class="cdk-visually-hidden" aria-live="polite">
      @if (search.position() > 0) {
        {{ 'profileSearch.announce' | translate: {
          current: search.position(),
          total: search.total(),
          section: (search.currentSectionKey() ?? '') | translate
        } }}
      } @else if (search.queryActive()) {
        {{ 'profileSearch.noHits' | translate }}
      }
    </span>
  </div>
}
